import angular from 'angular';

module.exports = angular.module('common.components.human-schedules', [
  require('./od-availability-group.js'),
  require('./od-edit-availability.js'),
  require('./od-show-availability.js'),
  require('./od-unavailabilities-table.js'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/human-schedules/index.js
 **/